export default "__VITE_ASSET__DAZKlPSX__"